enum ClaimStatusEnum {
  SUBMITTED = "SUBMITTED",
  UNDER_REVIEW = "UNDER_REVIEW",
  ACCEPTED = "ACCEPTED",
  REJECTED = "REJECTED",
  RESOLVED = "RESOLVED",
}

export default ClaimStatusEnum;
